import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  profileCardBtn: {
    height: 48,
    width: '100%',
  },
});
